import { UserManager } from "oidc-client-ts";
import { createContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const UserManagerContext = createContext<UserManager>(undefined!);
